<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import Multiselect from 'vue-multiselect'
import {
  required,
  minLength,
  sameAs,
  maxLength,
  numeric,
} from 'vuelidate/lib/validators'
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  getDocs
} from 'firebase/firestore/lite'
import { firebase } from '../../../../firebase-int'
const firestore = getFirestore(firebase)
/**
 * Register component
 */
export default {
  page: {
    title: 'Register',
    meta: [{ name: 'description', content: `Register to ${appConfig.title}` }],
  },
  components: { Layout, Multiselect },
  data() {
    return {
      form: {
        fullname: this.$store.state.auth.dummyFullName,
        phoneNumber: this.$store.state.auth.dummyUsername,
        password: this.$store.state.auth.dummyPassword,
        confirmPassword: this.$store.state.auth.dummyPassword,
      },

      regError: null,
      tryingToRegister: false,
      isRegisterError: false,

      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      showSuccessDialog: false,
      sex: ['Female', 'Male'],
      sexValue: null,
      ageGroup: ['Under 18', '18-25', '25-35', '35-45', '45-55', 'Over 55'],
      ageGroupValue: null,
      occupation: ['Student', 'Unemployed', 'Employed'],
      employedOccupation: [
        'Agriculture, Forestry and fishing',
        'Construction',
        'Wholesale, Retail',
        'Transportation, Storage',
        'Hospitality',
        'Information, Communication',
        'Professional, Scientific, Technical',
        'Admin., Support services',
        'Public Admin.',
        'Education',
        'Health',
        'Industry',
        'Financial',
        'Other',
      ],
      employedOccupationValue: null,
      occupationValue: null,

      tabIndex: 0
    }
  },
  validations: {
    form: {
      fullname: { required, minLength: minLength(2) },
      phoneNumber: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(10),
        numeric,
      },
      password: { required, minLength: minLength(6) },
      confirmPassword: {
        required,
        minLength: minLength(6),
        sameAsPassword: sameAs('password'),
      },
    },
  },
  computed: {},
  mounted() {
    this.sexValue = this.sex[0]
    this.ageGroupValue = this.ageGroup[1]
    this.occupationValue = this.occupation[0]
    this.employedOccupationValue = this.employedOccupation[0]
    //console.log('>>>>>> password: '+this.user.passwd)
  },
  methods: {
    ...authMethods,

    handleSubmit(e) {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.form.$pending || this.$v.form.$error) return
      this.tryToRegisterIn()
    },



    async getManadatoryCourses() {
      let coursesList = []
      const coursesListCol = collection(firestore, 'course')
      const q = query(
        coursesListCol,
        where('isMandatory', '==', true),
        orderBy('created', 'desc')
      )
      const coursesListSnapshot = await getDocs(q)
      coursesListSnapshot.forEach((doc) => {
        coursesList.push(doc.id)
      })
      console.log('>>>>> Courses list: ', coursesList)
      return coursesList
    },

    async tryToRegisterIn() {
      this.tryingToRegister = true
      this.isRegisterError = false
      var mandatoryCoursesList = [];
      mandatoryCoursesList = await this.getManadatoryCourses();
      // Reset the regError if it existed.
      //console.log('>>>>>>>> fullname: '+mandatoryCoursesList)
      this.regError = null
      return this.register({
        fullname: this.form.fullname,
        phoneNumber: this.form.phoneNumber,
        password: this.form.password,
        courseList: mandatoryCoursesList,
        sex: this.sexValue,
        ageGroup: this.ageGroupValue,
        occupation: this.occupation[this.tabIndex],
        employedOccupation: this.employedOccupationValue,
      })
        .then((token) => {
          this.tryingToRegister = false
          this.isRegisterError = false
          // Redirect to the originally requested page, or to the confirm-account page
          //   this.$router.push(
          //     this.$route.query.redirectFrom || { name: 'confirm-account' }
          //   )
          this.showSuccessDialog = true
          setTimeout(() => {
            this.$router.push({ name: 'login' })
          }, 2000)
          //console.log('>>>>>>> ' + JSON.stringify({ token }))
        })
        .catch((error) => {
          this.tryingToRegister = false
          this.regError = error.response
            ? error.response.data.message
            : 'Connection problem. Please try again.'
          this.isRegisterError = true
        })
    },

    getSignUpLabel() {
      if (this.tryingToLogIn)
        return this.$i18n.t('page.register.registering')
      else
        return this.$i18n.t('page.register.signUp')
    },
    getStyle() {
      if (this.$i18n.locale == 'am')
        return 'lighterTextAm'
      else
        return 'lighterTextEn'
    }
  },
}
</script>

<template>
  <Layout>
    <div class="account-pages my-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-10">
            <div class="card">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-lg-6 p-5">
                    <div class="mx-auto mb-5">
                      <a href="/">
                        <img src="@assets/images/logo.png" alt height="24" />
                        <h3 class="d-inline align-middle ml-1 text-logo">{{ $t("app.name") }}</h3>
                      </a>
                    </div>

                    <h6 class="h5 mb-0 mt-4">{{ $t("page.register.createAccount") }}</h6>
                    <p class="text-muted mt-0 mb-4">{{ $t("page.register.createDetails") }}</p>
                    <b-alert v-model="isRegisterError" variant="danger" dismissible>{{ regError }}</b-alert>

                    <b-alert v-model="showSuccessDialog" variant="success" dismissible>{{
                        $t("page.register.successfulSignup")
                    }}</b-alert>
                    <form @submit.prevent="handleSubmit" class="authentication-form">
                      <div class="form-group">
                        <label for="fullname" :class="getStyle()">{{ $t("page.register.fullName") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="user" class="icon-dual"></feather>
                            </span>
                          </div>
                          <input v-model="form.fullname" name="fullname" type="text" class="form-control"
                            :placeholder="$t('page.register.enterFullName')" :class="{
                              'is-invalid':
                                submitted && $v.form.fullname.$error,
                            }" />
                        </div>
                        <div v-if="submitted && $v.form.fullname.$error">
                          <span v-if="!$v.form.fullname.required">{{ $t("page.register.required") }}</span>
                          <span v-if="!$v.form.fullname.minLength">{{ $t("page.register.nameWarning") }}</span>
                        </div>
                      </div>




                      <div class="form-group">
                        <label for="sex" :class="getStyle()">{{ $t("page.member.sex") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge my_custom_div ">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="check-square" class="icon-dual"></feather>
                            </span>
                          </div>
                          <multiselect class="form-control" v-model="sexValue" :options="sex"></multiselect>
                        </div>
                      </div>



                      <div class="form-group">
                        <label for="ageGroup" :class="getStyle()">{{ $t("page.register.ageGroup") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge my_custom_div">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="git-commit" class="icon-dual"></feather>
                            </span>
                          </div>
                          <multiselect class="form-control" v-model="ageGroupValue" :options="ageGroup"></multiselect>
                        </div>
                      </div>




                      <!--div class="form-group">
                        <label for="occupation" :class="getStyle()">{{ $t("page.register.occupation") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge my_custom_div">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="git-commit" class="icon-dual"></feather>
                            </span>
                          </div>
                          <div>
                          <b-form-group v-slot="{ ariaDescribedby }" style="padding:10px">
                            <b-form-radio-group v-model="occupationValue" :options="occupation"
                              :aria-describedby="ariaDescribedby" name="radios-stacked" stacked></b-form-radio-group>
                          </b-form-group>

                          </div>
                          <div>
                            <multiselect class="form-control" v-model="ageGroupValue" :options="ageGroup"></multiselect>
                        

                          </div>
                          </div>
                      </div-->

                      <div>
                        <div>
                          <label for="occupation" :class="getStyle()">{{ $t("page.register.occupation") }}
                            <span class="text-danger">*</span>
                          </label>
                          <b-tabs pills justified class="navtab-bg mb-0"
                            active-nav-item-class="font-weight-bold text-primary" v-model="tabIndex">
                            <b-tab title="Student">
                              <!--p>{{tabIndex}}</p-->
                            </b-tab>
                            <b-tab title="Unemployed">
                              <!--p>{{tabIndex}}</p-->
                            </b-tab>
                            <b-tab title="Employed">
                              <div class="input-group input-group-merge my_custom_div mb-3">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    <feather type="briefcase" class="icon-dual"></feather>
                                  </span>
                                </div>
                                <multiselect class="form-control" v-model="employedOccupationValue"
                                  :options="employedOccupation"></multiselect>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </div>
                      </div>









                      <div class="form-group">
                        <label for="phoneNumber" :class="getStyle()">{{ $t("page.register.phone") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="phone" class="icon-dual"></feather>
                            </span>
                          </div>
                          <input v-model="form.phoneNumber" name="phoneNumber" type="phone" class="form-control"
                            :placeholder="$t('page.register.enterPhone')" :class="{
                              'is-invalid':
                                submitted && $v.form.phoneNumber.$error,
                            }" />
                        </div>
                        <div v-if="submitted && $v.form.phoneNumber.$error">
                          <span v-if="!$v.form.phoneNumber.required">{{ $t("page.register.required") }}</span>
                          <span v-if="
                            !$v.form.phoneNumber.minLength ||
                            !$v.form.phoneNumber.maxLength
                          ">{{ $t("page.register.phoneWarning") }}</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="password" :class="getStyle()">{{ $t("page.register.password") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="lock" class="icon-dual"></feather>
                            </span>
                          </div>
                          <input v-model="form.password" name="password" type="password" class="form-control"
                            :placeholder="$t('page.register.enterPassword')" :class="{
                              'is-invalid':
                                submitted && $v.form.password.$error,
                            }" />
                        </div>
                        <div v-if="submitted && $v.form.password.$error">
                          <span v-if="!$v.form.password.required">{{ $t("page.register.required") }}</span>
                          <span v-if="!$v.form.password.minLength">{{ $t("page.register.passwordWarning") }}</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="confirmPassword" :class="getStyle()">{{ $t("page.register.confirmPassword") }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather type="lock" class="icon-dual"></feather>
                            </span>
                          </div>
                          <input v-model="form.confirmPassword" name="confirmPassword" type="password"
                            class="form-control" :placeholder="$t('page.register.reenterPassword')" :class="{
                              'is-invalid':
                                submitted && $v.form.confirmPassword.$error,
                            }" />
                        </div>
                        <div v-if="submitted && $v.form.confirmPassword.$error">
                          <span v-if="!$v.form.confirmPassword.required">{{ $t("page.register.required") }}</span>
                          <span v-if="!$v.form.confirmPassword.minLength">{{ $t("page.register.passwordWarning")
                          }}</span>
                          <span v-if="!$v.form.confirmPassword.sameAsPassword">{{
                              $t("page.register.confirmPasswordWarning")
                          }}</span>
                        </div>
                      </div>

                      <div class="form-group mb-4">
                        <div class="custom-control custom-checkbox">
                          <input id="checkbox-signup" type="checkbox" class="custom-control-input" checked />
                          <label class="custom-control-label" for="checkbox-signup" :class="getStyle()">
                            {{ $t("page.register.accept") }}
                            <a href="javascript: void(0);" :class="getStyle()">{{ $t("page.register.terms") }}</a>
                          </label>
                        </div>
                      </div>

                      <div class="form-group mb-0 text-center">
                        <button class="btn btn-primary btn-block" type="submit" :disabled="tryingToRegister">{{
                            getSignUpLabel()
                        }}</button>
                      </div>
                    </form>
                  </div>

                  <div class="col-lg-6 d-none d-md-inline-block">
                    <div class="auth-page-sidebar">
                      <!--div class="overlay"></div-->
                      <div class="auth-user-testimonial">
                        <!--p class="font-size-24 font-weight-bold text-white mb-1"
													>I simply love it!</p
												>
												<p class="lead"
													>"It's a elegent templete. I love it very much!"</p
												>
												<p>- Admin User</p-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted" :class="getStyle()">
                  {{ $t("page.register.haveAccount") }}
                  <!--router-link
                    tag="a"
                    to="/login"
                    class="text-primary font-weight-bold ml-1" :class="getStyle()"
                    >{{ $t("page.register.login") }}</router-link-->
                  <router-link :to="{ name: 'login' }" class="text-primary font-weight-bold ml-1" :class="getStyle()">{{
                      $t("page.register.login")
                  }}</router-link>
                </p>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
  </Layout>
</template>


<style scoped>
.btn {
  font-size: 1rem;
}

.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1.0rem !important;
}

.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}

.form-control {
  padding: 0rem 0.75rem !important;
}
</style>


<style lang="scss" scoped>
.my_custom_div::v-deep .multiselect {
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 0px 0px 0px !important;
    border-radius: 5px;
    border: 0px solid #00000000 !important;
    background: #fff;
    font-size: 14px !important;
    margin: 0px !important;
  }

  .multiselect__single {
    font-family: inherit;
    font-size: 14px !important;
    touch-action: manipulation;
    vertical-align: middle !important;
  }
}
</style>
